/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * お客さま検索情報
 */
export interface Szoa104aRequestVisitSearchInfo { 
    /**
     * 内部お客さま番号リスト：数字
     */
    visitNoList: Array<string>;
}

